import type { ChangelogEntry } from "../types";

/** Interne prosjekter: prosjektraden tilbake, oppgavene under. */
export const INTERNPROSJEKTER_OPPGAVER_2026_10: ChangelogEntry = {
  id: "2026-10-27-internprosjekter-oppgaver",
  date: "2026-10-27",
  title: "Oppgavene ligger under hvert internprosjekt",
  summary:
    "Under Interne prosjekter på Mine oppgaver hadde prosjektene forsvunnet, så bare oppgavene og «Ny oppgave»-lenkene sto igjen. Nå har hvert prosjekt sin egen rad igjen, med oppgavene under.",
  sections: [
    {
      heading: "Mine oppgaver",
      items: [
        {
          title: "Prosjektraden er tilbake",
          kind: "rettet",
          body: "Du kan føre timer rett på prosjektet som før, og oppgavene på prosjektet ligger under det.",
        },
      ],
    },
  ],
};
